import { Camera, Engine, Mesh, SceneOptions, Vector3 } from '@babylonjs/core';
import { IHotspot, IIconProvider } from 'Framework/Components/Controls/XView/Core';
import { BaseHotspotOverlay } from 'Framework/Components/Controls/XView/Overlays/BaseHotspotOverlay';
import { Viewer360 } from 'Framework/Components/Controls/XView/XView.Viewer360';
import { MathHelper } from 'Framework/Helpers/MathHelper';

const defaultFovScaling = 1 / 1024;

export class HotspotFlat2DOverlay extends BaseHotspotOverlay {
    public constructor(
        engine: Engine,
        viewer: Viewer360,
        camera: Camera,
        imageRatio: number,
        iconProvider: IIconProvider,
        options?: SceneOptions
    ) {
        super(engine, camera, viewer, iconProvider, options);

        this._imageRatio = imageRatio;
    }

    protected override onMeshIconCreatedAsync(hotspot: IHotspot, mesh: Mesh): Promise<void> {
        let coordinates = hotspot.coordinates[0];

        if (MathHelper.isPlanCoordinates(coordinates)) {
            mesh.position.x = coordinates.x;
            mesh.position.y = (1 / this._imageRatio) - coordinates.y;
            mesh.position.z = 0;
            mesh.scaling = Vector3.One().scale(defaultFovScaling);
        }

        return Promise.resolve();
    }

    public override getCartesianCoordinatesOfShapeAsync(hotspot: IHotspot): Promise<Array<Vector3>> {
        const cartesianCoordinates = hotspot.coordinates.map(p => {
            return new Vector3(
                p.x,
                (1 / this._imageRatio) - p.y,
                0
            );
        });

        return Promise.resolve(cartesianCoordinates);
    }

    private readonly _imageRatio: number;
}
